import { postGeocoder } from "../../../api/services/axiosGeocoder.service";

/**
 * Parses an address using the geocoder service.
 * @param {Object} address - The address object to be parsed.
 * @returns {Promise<Object>} A promise that resolves to the parsed address response.
 */
export const parseGeocoder = (address) => {
  return postGeocoder("/address", {
    ...address,
    country: address.country.code,
  }).then((res) => res);
};
